module.exports = __webpack_public_path__ + "94ef32ff897b886f7c2530b95e5914a3.svg";